<header class="headerRow">
  <button (click)="getPreviousUrl()" mat-button matTooltip="Back to list">
    <mat-icon>arrow_back</mat-icon>
  </button>
  <h1>{{ userId !== 'new' ? "Edit" : "Add"}} User</h1>
</header>
<mat-accordion>
  <mat-expansion-panel expanded="true" class="userDetails">
    <mat-expansion-panel-header>
      <mat-panel-title> User Details </mat-panel-title>
    </mat-expansion-panel-header>
    <edit-user-details [role]="role" [userId]="userId"></edit-user-details>
  </mat-expansion-panel>
</mat-accordion>
@if (userId !== 'new') {
  <mat-accordion>
    <mat-expansion-panel class="userAddresses">
      <mat-expansion-panel-header>
        <mat-panel-title> User Addresses</mat-panel-title>
      </mat-expansion-panel-header>
      <edit-user-addresses [role]="role" [userId]="userId"></edit-user-addresses>
    </mat-expansion-panel>
  </mat-accordion>
}
@if (userId !== 'new') {
  <mat-accordion>
    <mat-expansion-panel class="orgDetails">
      <mat-expansion-panel-header>
        <mat-panel-title> Organisations </mat-panel-title>
      </mat-expansion-panel-header>
      <edit-organisations [role]="role" [userId]="userId"></edit-organisations>
    </mat-expansion-panel>
  </mat-accordion>
}
@if (userId !== 'new') {
  <mat-accordion>
    <mat-expansion-panel class="groupDetails">
      <mat-expansion-panel-header>
        <mat-panel-title> Groups </mat-panel-title>
      </mat-expansion-panel-header>
      <edit-groups [role]="role" [userId]="userId"></edit-groups>
    </mat-expansion-panel>
  </mat-accordion>
}
